var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShelve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66671 10.0001C1.66671 14.6025 5.39767 18.3334 10 18.3334C14.6024 18.3334 18.3334 14.6025 18.3334 10.0001C18.3334 5.39771 14.6024 1.66675 10 1.66675C5.39767 1.66675 1.66671 5.39771 1.66671 10.0001Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4426 5.8333C14.0851 5.8333 14.4084 5.0583 13.9559 4.60164L10.7426 1.35747C10.3334 0.944971 9.66673 0.944971 9.25756 1.35747L6.04423 4.60164C5.59173 5.0583 5.91506 5.8333 6.55756 5.8333L13.4426 5.8333Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.9999L11.6667 3.50073L8.33341 3.50073L8.33341 9.9999H11.6667Z",
    fill: "#6C6C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 9.99992C8.33341 10.9204 9.07961 11.6666 10.0001 11.6666C10.9206 11.6666 11.6667 10.9204 11.6667 9.99992C11.6667 9.07944 10.9206 8.33325 10.0001 8.33325C9.07961 8.33325 8.33341 9.07944 8.33341 9.99992Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelve);
export default __webpack_public_path__ + "static/media/shelve.c7ab0df500f4e1fd09d3e0e97a80a392.svg";
export { ForwardRef as ReactComponent };